import Vue from 'vue'
import vuetify from './plugins/vuetify.js'
import App from './App.vue'
import router from './router'
import store from './store/store'
import './registerServiceWorker'
import {mapGetters, mapState} from 'vuex'
import { auth } from './FirebaseConfig.js'
import moment from 'moment'
import VueFbCustomerChat from 'vue-fb-customer-chat'
 
Vue.use(VueFbCustomerChat, {
  page_id: 944385665700866, 
  theme_color: '#333333', // theme color in HEX
  locale: 'es_ES', // default 'en_US'
})
Vue.config.productionTip = false
let app = null

auth.onAuthStateChanged( (user)=>{
	if(user) {
		store.state.Sesion.sesion = true
	}
	Vue.mixin({
		data: ()=>({
			requerido: v => !!v || 'Este campo es requerido',
			min_8: value => value && value.length >= 8 || 'Mínimo 8 caracteres',
			tam_9: value => value && value.length==9 || 'Se necesitan 9 caracteres',
			correo_electronico: v => /.+@.+\..+/.test(v) || 'El correo debe ser válido.',
			tam_11: value => value && value.length==11 || 'Se necesitan 11 caracteres',
			max_140: value => value && value.length<=140|| 'Máximo 140 caracteres',

		}),
		computed:{
			...mapGetters({
				$contenido: 'CMS/contenido'
			}),
			...mapState({
				cargando: state => state.CMS.cargando,
				Ayudas: state => state.Ayudas,
				$sesion: state => state.Sesion.sesion
			}),
		},
		filters: {
			resumen: val => `${val.substr(0, 89)} ${ val.length > 89 ? '(...)' : ''}`,
			fecha_completa: val => moment(val).format('DD/MM/YYYY HH:mm')
		}
	})


	if(!app){
		app = new Vue({
			router,
			store,
			vuetify,
			render:h => h(App)
		}).$mount('#app')
	}
})